{
  "chart": {
    "how-to-measure": "Cómo medir",
    "select-your-size-we-ll-notify-you-once-it-s-back-in-stock": "Selecciona tu talla y te avisaremos cuando vuelva a estar disponible"
  },
  "page": {
    "plans": {
      "try-now": "Probar ahora",
      "what-included": "¿Qué incluye?",
      "popular-plan": "Popular"
    },
    "about-us": {
      "title": "Sobre nosotros",
      "intro": "Goodchart nació en 2023 con la misión de transformar tu experiencia de compra de ropa. Nuestro equipo de entusiastas de la moda, diseñadores y expertos en tecnología está aquí para ayudarte a encontrar ropa que realmente complemente tu cuerpo. Con nuestra interfaz fácil de usar y algoritmos avanzados, ofrecemos recomendaciones personalizadas basadas en tus medidas, estilo y estilo de vida.",
      "community": "Di adiós al compromiso y hola a la confianza y la comodidad. Únete a nuestra comunidad inclusiva de clientes satisfechos y embárcate en un viaje de compras lleno de alegría con Goodchart.",
      "tagline": "Desata tu estilo. Vive la euforia de la moda pura.",
      "founders": "Fundadores",
      "cedric-photo-alt": "Cedric, cofundador de Goodchart y director de producto",
      "nick-photo-alt": "Nick, cofundador de Goodchart y director de operaciones",
      "quentin-photo-alt": "Quentin, director de tecnología de la información de Goodchart",
      "cedric": "Cedric",
      "cedric-role": "Cofundador de Goodchart y director de producto",
      "nick": "Nick",
      "nick-role": "Cofundador de Goodchart y director de operaciones",
      "quentin": "Quentin",
      "quentin-role": "Director de tecnología de la información de Goodchart"
    },
    "contact": {
      "title": "Contáctanos",
      "lets-talk": "Hablemos",
      "subtitle": "Completa el formulario y nuestro equipo se pondrá en contacto por correo electrónico.",
      "first-name": "Nombre",
      "first-name-required": "El nombre es obligatorio",
      "last-name": "Apellido",
      "last-name-required": "El apellido es obligatorio",
      "email": "Correo electrónico",
      "email-required": "El correo electrónico es obligatorio",
      "email-invalid": "Introduce una dirección de correo electrónico válida",
      "message": "Mensaje",
      "message-required": "El mensaje es obligatorio",
      "sending": "Enviando...",
      "send": "Enviar",
      "success": "¡Tu formulario ha sido enviado a nuestro equipo!"
    },
    "email-unsubscribe": {
      "title": "Suscripción por correo electrónico",
      "unsubscribe-confirm": "¿Seguro que quieres darte de baja de nuestra lista de correo?",
      "unsubscribe-info": "Al darte de baja, dejarás de recibir novedades, boletines y ofertas especiales de nuestra parte.",
      "cancel": "Cancelar",
      "confirm-unsubscription": "Confirmar baja",
      "resubscribe-confirm": "¿Te gustaría volver a suscribirte a nuestra lista de correo?",
      "resubscribe-info": "Mantente al día con nuestras últimas noticias, ofertas exclusivas y novedades interesantes.",
      "resubscribe": "Volver a suscribirse",
      "unsubscribe-success": "Baja de tu correo electrónico realizada correctamente",
      "unsubscribe-error": "Hubo un problema al dar de baja tu correo electrónico",
      "resubscribe-success": "Suscripción de tu correo electrónico realizada correctamente",
      "resubscribe-error": "Hubo un problema al volver a suscribir tu correo electrónico"
    },
    "back-to-stock": {
      "notify-me-product": "Avísame para el producto {{title}} - {{variant}}"
    },
    "help": {
      "title": "Centro de ayuda",
      "description": "Guías para configurar y usar Goodchart en tu tienda Shopify.",
      "search": "Buscar artículos de ayuda",
      "loading": "Cargando…",
      "load-failed": "No se pudo cargar el centro de ayuda. Inténtalo de nuevo en un momento.",
      "no-results": "Ningún artículo coincide con tu búsqueda.",
      "no-articles": "Todavía no hay artículos de ayuda.",
      "topics": {
        "getting-started": "Primeros pasos",
        "size-charts": "Guías de tallas",
        "table-charts": "Tablas",
        "assigning-products": "Asignar productos",
        "storefront-display": "Visualización en la tienda",
        "chart-import": "Importar guías",
        "size-recommendations": "Recomendaciones de talla",
        "plans-billing": "Planes y facturación",
        "troubleshooting": "Solución de problemas"
      },
      "back": "Volver al centro de ayuda",
      "browse": "Ir al centro de ayuda",
      "not-found": {
        "title": "Artículo no encontrado",
        "description": "Este artículo no existe o ya no está disponible."
      },
      "updated": "Última actualización: {{date}}",
      "related": "Más sobre {{topic}}",
      "contact": {
        "title": "¿Todavía necesitas ayuda?",
        "description": "Envíanos un mensaje y nuestro equipo te responderá por correo electrónico. Si tienes la app Goodchart instalada, también puedes preguntar en su chat de soporte.",
        "link": "Contáctanos"
      },
      "article-load-failed": "No se pudo cargar este artículo. Inténtalo de nuevo en un momento."
    }
  },
  "error": {
    "error-occurred": "¡Se produjo un error!",
    "failed-to-subscribe-to-this-product": "¡No se pudo suscribir a este producto!",
    "failed-to-get-your-size-recommendation-please-try-again-later": "No se pudo obtener tu recomendación de talla. Inténtalo de nuevo más tarde."
  },
  "common": {
    "close": "Cerrar"
  },
  "component": {
    "size-recommender": {
      "form": {
        "title": "Encuentra tu mejor talla",
        "subtitle": "Unos datos rápidos para un mejor ajuste",
        "shopping-for": "COMPRANDO PARA",
        "gender-women": "Mujer",
        "gender-men": "Hombre",
        "gender-other": "Otro",
        "measurements": "MEDIDAS",
        "height": "Altura",
        "height-required": "La altura es obligatoria",
        "height-min": "La altura mínima es 1",
        "weight": "Peso",
        "weight-required": "El peso es obligatorio",
        "weight-min": "El peso mínimo es 1",
        "preferred-fit": "Ajuste preferido",
        "continue": "Continuar"
      },
      "result": {
        "suggested-size": "Talla sugerida:",
        "no-fit": "Lamentablemente, parece que no tenemos una talla ideal por el momento. Te recomendamos volver a consultar más tarde para ver más opciones.",
        "verdict": "Veredicto:",
        "similar-variants": "Variantes similares:",
        "proceed": "Continuar con esta variante",
        "estimate-disclaimer": "(Estimación basada en la marca y la información del usuario, los resultados pueden variar.)",
        "back": "Atrás"
      }
    },
    "footer": {
      "terms": "Términos",
      "privacy": "Privacidad",
      "help-center": "Centro de ayuda",
      "blog": "Blog",
      "about": "Acerca de",
      "contact-us": "Contáctanos"
    },
    "conversion-table": {
      "description": "Según el ajuste, pueden aparecer ligeras diferencias en las medidas. Encuentra tu talla correcta en la tabla a continuación.",
      "size": "Talla"
    },
    "add-to-cart-btn": {
      "notify-me-when-available": "Avísame cuando esté disponible",
      "notify-me": "Avísame",
      "out-of-stock": "Agotado"
    },
    "restock-form": {
      "your-name": "Tu nombre",
      "your-email": "Tu dirección de correo electrónico",
      "email-required": "El correo electrónico es obligatorio",
      "subscribing": "Suscribiendo...",
      "notify-me": "AVÍSAME",
      "agree-terms": "Al continuar, aceptas nuestros",
      "terms-privacy": "Términos y política de privacidad",
      "news-opt-in": "Me gustaría recibir novedades sobre nuevos lanzamientos y otro contenido inspirador (opcional)"
    },
    "back-to-stock-result": {
      "new-subscription": "Gracias, te enviaremos un correo cuando la talla <span class=\"font-bold\">{{name}}</span> esté disponible.",
      "existing-subscription": "¡Ya tenemos tu correo electrónico! Te avisaremos en cuanto la talla <span class=\"font-bold\">{{name}}</span> vuelva a estar en stock.",
      "back-to-collection": "Volver a la colección"
    },
    "chart": {
      "find-your-size": "Encuentra tu talla",
      "size-guide": "Guía de tallas",
      "recommendation": "Recomendación",
      "body-measurements": "MEDIDAS CORPORALES",
      "model-measurements": "MEDIDAS DEL MODELO",
      "model-description": "El modelo {{name}} mide {{height}}cm y usa la talla {{variant}}.",
      "size-conversion": "CONVERSIÓN DE TALLAS"
    },
    "landing": {
      "learn": "Aprender",
      "learn-more": "Saber más",
      "blog": "Blog",
      "blog-description": "Explora los últimos anuncios, actualizaciones de productos y más",
      "help-center": "Centro de ayuda",
      "help-center-description": "Primeros pasos, artículos prácticos e instrucciones paso a paso",
      "demo": "Demostración",
      "demo-description": "Mira los widgets de Goodsize en acción en nuestra tienda de ejemplo",
      "services": "SERVICIOS",
      "contact": "Contacto",
      "privacy": "Privacidad",
      "goodsize": "Goodsize",
      "goodsize-description": "Descubre nuestra solución de ajuste para tu negocio",
      "goodchart": "Goodchart",
      "goodchart-description": "Tabla de tallas visual para aumentar la conversión"
    },
    "product-variant-completer": {
      "title": "Elige tus opciones",
      "body": "Selecciona tu {{option}} para continuar.",
      "body-multiple": "Selecciona las opciones restantes para continuar.",
      "body-notify": "¿Qué {{option}} debemos vigilar por ti?",
      "confirm": "Continuar",
      "cancel": "Cancelar",
      "empty": "Esta combinación no está disponible."
    },
    "checkout-variant": {
      "label": "Estás comprando {{variant}}",
      "aria-label": "Cambiar la variante que estás comprando",
      "sold-out": "agotado"
    }
  },
  "promotion": {
    "BlackFriday": {
      "name": "Black Friday"
    }
  }
}
